import { z } from '../zod.js';
import { DashboardUrlField } from '../shared/dashboardUrl';
import { PaginatedListSchema } from '../shared/paginatedList';
import { BaseChargeResponseValidationSchema, VariantValidationSchema } from '../charge/index.js';
import { PriceSnapshotSchema } from '../charge/priceSnapshot.js';

export const PaymentResponseValidationSchema = BaseChargeResponseValidationSchema.extend({
  productId: z.string().nullish().meta({
    description: 'Product ID for the purchased item.',
  }),
  productTitle: z.string().nullish().meta({
    description: 'Human-readable product name.',
  }),
  productPrice: z.number().nullish().meta({
    description: 'Base product price in the smallest currency unit.',
  }),
  priceId: z.string().nullish().meta({
    description: 'Id of the price the customer selected at checkout.',
  }),
  priceSnapshot: PriceSnapshotSchema.nullish(),
  payWhatYouWantPrice: z.number().nullish().meta({
    description:
      'Pay-what-you-want amount selected by the customer, in the smallest currency unit.',
  }),
  discountedFromPrice: z.number().nullish().meta({
    description: 'Original pre-discount price in the smallest currency unit. Marketing tool only.',
  }),
  setupFee: z.number().nullish().meta({
    description: 'One-time setup fee in the smallest currency unit.',
  }),
  quantity: z.number().nullish().meta({
    description: 'Quantity purchased for this payment record.',
  }),
  sku: z.string().nullish().meta({
    description: 'SKU for the purchased product or variant.',
  }),
  variants: z.array(VariantValidationSchema).nullish().meta({
    description: 'Selected product variants and chosen options.',
  }),
  licenseKeyId: z.string().nullish().meta({
    description: 'Associated license key ID, if generate license keys is enabled.',
  }),
}).openapi('Payment', { description: '' });

export const GetPaymentsResponseValidationSchema = PaginatedListSchema(
  PaymentResponseValidationSchema,
);

export const PaymentDetailResponseValidationSchema = z
  .object({
    data: PaymentResponseValidationSchema,
  })
  .meta({ id: 'PaymentDetailResponse', description: 'Envelope containing one payment.' });

export const PaymentToolDataValidationSchema = PaymentResponseValidationSchema.extend({
  dashboardUrl: DashboardUrlField,
});

export const PaymentDetailToolResponseValidationSchema = z.object({
  data: PaymentToolDataValidationSchema,
});

export const PaymentsToolResponseValidationSchema = PaginatedListSchema(
  PaymentToolDataValidationSchema,
);
